import React from 'react';
import { Link } from 'react-router-dom';

function RcFamigliaQuoteInfo({ rcFamigliaQuote, setShowGreeniaAI }) {
  return (
    <div className="w-75 ms-auto mb-3">
      <div className="bg-success border border-success p-3 rounded-3 shadow">
        <h5 className="fs-6 text-white">Nuovo Preventivo Condominio</h5>
        <hr />
        <div>
          <div>
            <div className="row">
              <div className="col-12">
                <p className="m-0 text-white">
                  <small>
                    <strong>
                      Premio Totale:
                    </strong>
                    {' '}
                    {parseFloat(rcFamigliaQuote?.quotes?.total_price).toFixed(2)}
                    {' '}
                    €
                  </small>
                </p>
              </div>

              {rcFamigliaQuote?.quotes?.quotations?.map((quote, index) => (
                <div className="row" key={index}>
                  <div className="col-12">
                    <p className="m-0 text-white">
                      <small>
                        <strong>
                          Titolo:
                        </strong>
                        {' '}
                        {quote?.quote_name}
                      </small>
                    </p>
                  </div>

                  <div className="col-12">
                    <hr />
                  </div>
                </div>
              ))}

            </div>
            <hr />
            <div className="row mt-2">
              <div className="col-12">
                <Link
                  onClick={() => setShowGreeniaAI(false)}
                  className="btn btn-light"
                  to={`/quote/rc-famiglia/${rcFamigliaQuote?.fastQuoteId}`}
                >
                  Procedi con il Preventivo
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RcFamigliaQuoteInfo;
